import { Link } from 'react-router-dom';
import { topRankedCharacters } from '@/mocks/characters';

export default function RankingSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-18">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        {/* 榜单标题区 */}
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-700">
            <i className="ri-bar-chart-line" />
            每周更新
          </span>
          <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">角色人气榜 TOP 10</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-600">
            基于用户收藏、浏览热度与社区评分综合计算。点击榜单角色，可进入对应详情页查看动漫人物介绍与配音演员信息。
          </p>
          <Link
            to="/characters"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            浏览完整角色百科
            <i className="ri-arrow-right-line" />
          </Link>

          <div className="mt-8 hidden lg:block">
            <div className="rounded-2xl border border-background-200/70 bg-background-100 p-5">
              <p className="text-sm font-medium text-foreground-800">榜单小贴士</p>
              <p className="mt-2 text-xs leading-5 text-foreground-500">
                榜单只是热度参考，每位妖精角色都有独特魅力。常来逛逛，也许你会邂逅自己的本命角色。
              </p>
            </div>
          </div>
        </div>

        {/* 榜单列表 */}
        <ol className="lg:col-span-8 space-y-3">
          {topRankedCharacters.map((char, i) => (
            <li key={char.id}>
              <Link
                to={`/character/${char.id}`}
                className="group flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-3 pr-4 transition-colors hover:border-primary-300 hover:bg-background-100"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                    i < 3 ? 'bg-accent-500 text-primary-900' : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  {char.rank}
                </span>
                <img src={char.image} alt={char.name} className="h-14 w-11 shrink-0 rounded-md object-cover object-top" loading="lazy" />
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-700">{char.name}</h3>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">{char.title} · {char.work}</p>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${char.popularity}%` }} />
                    </div>
                    <span className="w-8 text-right text-xs font-medium text-foreground-600">{char.popularity}%</span>
                  </div>
                </div>
                <span className="hidden sm:flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800 whitespace-nowrap">
                  <i className="ri-mic-line" />
                  {char.seiyuuName}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}